import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout/Layout";

import "bootstrap/dist/css/bootstrap.min.css";

import Dashboard from "./pages/Dashboard";
import Posts from "./pages/Posts";
import Portfolio from "./pages/Portfolio";
import Tags from "./pages/Tags";
import Categories from "./pages/Categories";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import SocialLinks from "./pages/SocialLinks";
import PostEditor from "./pages/Posts/PostEditor";
import Edit from "./pages/Posts/Edit";
import ProjectEditor from "./pages/Projects/ProjectEditor";
import Projects from "./pages/Projects";
import EditProject from "./pages/Projects/Edit";

// ProtectedRoute component
const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    
    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }
    
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    
    return children;
};

const App = () => {
    return (
        <ThemeProvider>
            <Router>
                <AuthProvider>
                    <Routes>
                        {/* Public route */}
                        <Route path="/login" element={<Login />} />
                        
                        {/* Protected routes */}
                        <Route
                            path="/*"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Routes>
                                            <Route path="/" element={<Dashboard />} />
                                            <Route path="posts" element={<Posts />} />
                                            <Route path="posts/create" element={<PostEditor />} />
                                            <Route path="posts/edit/:postId" element={<Edit />} />
                                            <Route path="portfolio" element={<Portfolio />} />
                                            <Route path="projects/create" element={<ProjectEditor />} />
                                            <Route path="projects" element={<Projects />} />
                                            <Route path="projects/edit/:projectId" element={<EditProject />} />
                                            <Route path="tags" element={<Tags />} />
                                            <Route path="categories" element={<Categories />} />
                                            <Route path="profile" element={<Profile />} />
                                            <Route path="social-links" element={<SocialLinks />} />
                                        </Routes>
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </Router>
        </ThemeProvider>
    );
};

export default App;
